import React, { useContext } from 'react';
import { Button, notification, Popconfirm } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { SwapOutlined } from '@ant-design/icons';
import { updateThirdPartyBkAccountStatus } from 'services/thirdParty';
import { AuthContext } from 'components/Auth/Auth';
import ButtonOperation from 'components/ButtonOperation';


export type ThirdPartyBkAccountStatusButtonProps = ButtonProps & {
  
tpid:number
tpbkid  : number;
status : string;
  refetch: () => void;
  fromextra?:boolean;
  style?:any
};

const ThirdPartyBkAccountStatusButton: React.FC<ThirdPartyBkAccountStatusButtonProps> = ({
  size = 'small',
  tpid,
  tpbkid  ,
  status ,
  refetch,
  fromextra,
  style,
  ...props
}) => {
  const { isInspect } = useContext(AuthContext);
  let newStatus = '',
    statuslabel = '';
  switch (status ) {
    case 'INIT':
      newStatus = 'VALID';
      statuslabel = 'Validate';
      break;
    case 'VALID':
      newStatus = 'DISABLED';
      statuslabel = 'Disable';
      break;
    case 'DISABLED':
      newStatus = 'END';
      statuslabel = 'Terminate';
      break;
    case 'END':
      newStatus = 'VALID';
      statuslabel = 'Validate';
      break;
  }
  return (
    <div>
    {isInspect ? (
      <ButtonOperation
        htmlType="button"
        icon={
          <SwapOutlined
            style={{ borderColor: '#1db5a1' }}
            {...props}
            twoToneColor="#52c41a"
          />
        }
        comcode={statuslabel}
        size="large"
        style={{ ...style }}
      />
    ) : (
    <Popconfirm
      title="Sure to change the status?"
      onConfirm={() => {
        updateThirdPartyBkAccountStatus({
          tpbkid ,
          bkstatus : newStatus,
          tpid: tpid,
}).then((res) => {
          notification.success({ message: res.message });
          refetch();
        });
      }}
    >
      <Button
        icon={<SwapOutlined twoToneColor="#52c41a" />}
        onClick={() => {}}
        {...props}
        style={fromextra?{ width: '100%', height: 60 }:{
          width: 100,
          height: 40,
          marginLeft: 5,
          marginRight: 5,
          marginBottom: 5,
        }}
      >
        {statuslabel}
      </Button>
    </Popconfirm>
 )}
 </div>)
};

export default ThirdPartyBkAccountStatusButton;
